import clsx from 'clsx';
import type { FC } from 'react';
import { Radio } from '@/components/raven/Inputs/Radio';
import { Label } from '@/components/raven/Inputs/Label';
import { Checkmark } from '@themaven-net/raven-assets/index';

import styles from './styles.module.css';
import type { PollDataOption } from './util';

export const PollOption: FC<{
	allScores: number[];
	hasVoted: boolean;
	isClosed: boolean;
	onChange: () => void;
	option: PollDataOption;
	selectedOption: null | string;
}> = ({ allScores, hasVoted, isClosed, onChange, option, selectedOption }) => {
	const isOpen = !isClosed;
	const isSelectedOption = option.id === selectedOption;
	const isNotSelectedOption = selectedOption && option.id !== selectedOption;

	// Determine if this option is in the lead (highest score) when poll is open
	const isLeading =
		isOpen && !option.isWinner && option.score === Math.max(...allScores);

	return (
		<div
			className={clsx(styles.pollOption, {
				[styles.pollOptionNonSelected]:
					(isClosed && !option.isWinner) || isNotSelectedOption,
				[styles.pollOptionVoted]: isOpen && hasVoted && isSelectedOption,
				[styles.pollWinner]: option.isWinner || isLeading,
			})}
			key={option.id}
		>
			{isOpen ? (
				<Radio
					checked={isSelectedOption}
					className={styles.pollOptionRadio}
					disabled={hasVoted}
					id={`input-${option.id}`}
					label={option.value}
					labelHidden={hasVoted || isClosed}
					name="poll-option"
					onChange={onChange}
					value={option.id}
				/>
			) : null}
			<Label
				as="label"
				className={styles.pollOptionLabel}
				htmlFor={`progress-${option.id}`}
				labelHidden={isOpen && !hasVoted}
			>
				<div className={styles.pollOptionText}>
					<span className={styles.pollOptionValue}>
						{option.value}
						{hasVoted && isSelectedOption && (
							<span className={styles.pollOptionVotedIcon}>
								<Checkmark />
							</span>
						)}
					</span>
					<span className={styles.pollOptionPercentage}>
						{option.percentage}%
					</span>
				</div>
				<progress
					className={clsx(styles.pollProgressBar, {
						[styles.pollProgressBarVoted]:
							isOpen && hasVoted && isSelectedOption,
						[styles.pollProgressBarWinner]: option.isWinner,
					})}
					id={`progress-${option.id}`}
					max="100"
					value={option.percentage}
				/>
			</Label>
		</div>
	);
};
